export default "__VITE_ASSET__B89rJ3l$__"